import { render } from "./CargoPublicoFamiliar.vue?vue&type=template&id=2fc45c82"
import script from "./CargoPublicoFamiliar.vue?vue&type=script&lang=js"
export * from "./CargoPublicoFamiliar.vue?vue&type=script&lang=js"

import "./CargoPublicoFamiliar.vue?vue&type=style&index=0&id=2fc45c82&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__